export const progressConstants = {
    UPDATE: 'PROGRESS_UPDATE',
};
